import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {gqlGroupMember} from './getGroupMembers.api';

interface GroupMembersData {
    groupMembers: void
    myTravellers: void
    myGroupMembers: void,
    groupMembersInMyGroup: {
        data: GroupMember[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_GROUP_MEMBERS_QUERY = gql`
  query groupMembersInMyGroup($groupRef: String!, $count: Int!, $page: Int!, $where: WhereConditions, $hasRoomMember: QueryGroupMembersInMyGroupHasRoomMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    groupMembersInMyGroup(groupRef: $groupRef, first: $count, page: $page, where: $where, hasRoomMember: $hasRoomMember, orderBy: $orderBy){
      data {
        ${gqlGroupMember}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getGroupMembersInMyGroup = (groupRef: string, count: number, page: number, where?: any, orderBy?: any, hasRoomMember?: any) => useQuery<GroupMembersData>(
    GET_GROUP_MEMBERS_QUERY,
    {
        variables: {
            groupRef,
            count,
            page,
            where,
            orderBy,
            hasRoomMember,
        },

    }
);

export default getGroupMembersInMyGroup;
